export const BIGDATA_QUERY = `
    query BigRequests($bigRequests: [BigRequest!]!) {
        bigRequests(requests: $bigRequests) {
            data
            error {
                errortype,
                message
            }
        }
    }
`;

export const  MOTIF_QUERY= `   query occurrences($prange: [ChromosomeRangeInput]!, $range: [GenomicRegionInput!],$peaks_accession: String, $consensus_regex: String, $limit: Int, $offset: Int, $assembly: String) {
    meme_occurrences(genomic_region: $range, peaks_accession: $peaks_accession, consensus_regex: $consensus_regex, limit: $limit, offset: $offset) {
        motif {
            pwm
            peaks_file {
                assembly
                accession
                dataset_accession
            }
        }
        genomic_region {
            chromosome
            start
            end
        }
    }
    peaks(file_accession: $peaks_accession, range: $prange, assembly: $assembly) {
      peaks {
        chrom
        chrom_start
        chrom_end
      }
    }
}`;
